import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
const _exp = /*#__PURE__*/() => Flex.Column;
const TitleWrapper = /*#__PURE__*/styled(_exp())({
  name: "TitleWrapper",
  class: "t5x1fvb",
  propsAsIs: true
});
export const ErrorMessagesLayout = ({
  titleSlot,
  descriptionSlot
}: {
  titleSlot: ReactNode;
  descriptionSlot: ReactNode;
}) => {
  return <TitleWrapper gap="s300">
      <Flex.Row alignItems="center" gap="s300" justifyContent="center">
        <Icon name="Forbid" colorPath="content.danger.c500" size="lg" />
        <Text variant="titleXL" align="center" dataId="errorMessage.title">
          {titleSlot}
        </Text>
      </Flex.Row>
      <Text variant="bodyM" colorPath="content.neutral.c600" align="center" dataId="errorMessage.description">
        {descriptionSlot}
      </Text>
    </TitleWrapper>;
};

require("./ErrorMessagesLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ErrorMessagesLayout.tsx");